import axios from 'axios';
import { IResponse } from '~/services/api/types';
import { ICarePlanMedicalNote } from './types';

const apiUrl = 'care-plan-medical-notes';

export const getList = (patientId: number): IResponse<ICarePlanMedicalNote[]> =>
  axios({
    method: 'get',
    url: `${apiUrl}/by-patient-id/${patientId}`,
  });

export const create = (
  patientId: number,
  data: ICarePlanMedicalNote,
): IResponse<ICarePlanMedicalNote> =>
  axios({
    method: 'post',
    url: apiUrl,
    data,
    params: {
      patientId,
    },
  });

export const update = (data: ICarePlanMedicalNote): IResponse<ICarePlanMedicalNote> =>
  axios({
    method: 'put',
    url: apiUrl,
    data,
  });

export const remove = (id: number): IResponse<void> =>
  axios({
    method: 'delete',
    url: `${apiUrl}/${id}`,
  });
